import React from "react";
import beats1 from "../../../images/beats1.jpg";
import beats2 from "../../../images/beats2.jpg";
import beats3 from "../../../images/beats3.jpg";
import beats4 from "../../../images/beats4.jpg";
import beats5 from "../../../images/beats5.jpg";
import beats6 from "../../../images/beats6.jpg";
import beats7 from "../../../images/beats7.jpg";
import beats8 from "../../../images/beats8.jpg";
import beats9 from "../../../images/beats9.jpg";
import beats10 from "../../../images/beats10.jpg";
import beats11 from "../../../images/beats11.jpg";
import beats12 from "../../../images/beats12.jpg";
import beats13 from "../../../images/beats13.jpg";
import beats14 from "../../../images/beats14.jpg";
import EngagementCarouselPage from "../../ui/EngagementCarouselPage";

const Beats = () => (
  <EngagementCarouselPage
    title="Beats of a Kind"
    paragraphs={[
      "Music has an amazing ability to empower, inspire, captivate and rally people together for something greater than themselves. Just as music is a universal language, so is Kindness and it is with the transformative power of music that we wanted to kick off World Kindness Week, we presented an event at the Carter Road Promenade which aimed to bring together an ensemble of music artists, each doing performances that were socially geared and celebrated the human spirit. Our music collaborators for this included – True School of Music, NSPA, and acclaimed Indie pop artists- Alisha Pais and Tejas Menon",
    ]}
    images={[beats1, beats2, beats3, beats4, beats5, beats6, beats7, beats8, beats9, beats10, beats11, beats12, beats13, beats14]}
  />
);

export default Beats;
